import { LabelLarge, LabelSmall } from '../typography/Label'
import CardButton from './CardButton'
import { Link } from 'react-router-dom'

function Card({
  heading,
  text,
  buttonLabel,
  navigateTo,
  backgroundColor,
  buttonMargin,
}) {
  return (
    <Link to={navigateTo} style={{ textDecoration: 'none' }}>
      <div
        className="card"
        style={{
          backgroundColor: backgroundColor && backgroundColor,
        }}
      >
        <LabelLarge style={{ color: 'var(--white) ' }}>{heading}</LabelLarge>
        {text && (
          <LabelSmall
            style={{
              marginTop: '5px',
              color: 'rgba(255, 255, 255, 0.85)',
              fontWeight: '500',
            }}
          >
            {text}
          </LabelSmall>
        )}
        {buttonMargin && <div style={{ height: '20px' }} />}
        <CardButton>{buttonLabel}</CardButton>
      </div>
    </Link>
  )
}

export default Card
